import equipmentAddEffect from "./equipment-add-effect";
import equipmentListEffect from "./equipment-list-effect";
import equipmentRemoveEffect from "./equipment-remove-effect";
import equipmentSaveEffect from "./equipment-save-effect";

const { combineEpics } = require("redux-observable");

const equipmentEffects = combineEpics(
	equipmentListEffect,
	equipmentAddEffect,
	equipmentRemoveEffect,
	equipmentSaveEffect
);

export default equipmentEffects;

